import './challenge.css';
import { useEffect, useState } from 'react';
import checkIcon from '../images/check-mark1.png';
import xIcon from '../images/red-x.png';
import clearIcon from '../images/white-box.png';

export default function Challenge() {
  const statusOptions = [
    {
      status: 'V',
      description: 'Challenge completed',
      icon: checkIcon,
    },
    {
      status: 'X',
      description: 'Challenge not completed',
      icon: xIcon,
    },
    {
      status: 'clear',
      description: 'Clear cell',
      icon: null,
    },
  ];

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const [monthTitles, setMonthTitles] = useState(() => {
    const savedTitles = JSON.parse(localStorage.getItem('monthTitles'));
    return savedTitles || Array(12).fill('');
  });

  useEffect(() => {
    localStorage.setItem('monthTitles', JSON.stringify(monthTitles));
  }, [monthTitles]);

  const handleTitleChange = (index, value) => {
    const newTitles = [...monthTitles];
    newTitles[index] = value;
    setMonthTitles(newTitles);
  };

  const [selectedStatus, setSelectedStatus] = useState(null);
  const [tableChallenge, setTableChallenge] = useState(() => {
    try {
      const savedData = localStorage.getItem('tableChallenge');
      return savedData
        ? JSON.parse(savedData)
        : Array.from({ length: 31 }, () => Array(12).fill(null));
    } catch (error) {
      console.error('Error parsing localStorage data:', error);
      return Array.from({ length: 31 }, () => Array(12).fill(null));
    }
  });

  useEffect(() => {
    localStorage.setItem('tableChallenge', JSON.stringify(tableChallenge));
  }, [tableChallenge]);

  useEffect(() => {
    localStorage.setItem('selectedStatus', JSON.stringify(selectedStatus));
  }, [selectedStatus]);

  console.log('selected status:::', selectedStatus);

  const handleStatusChange = (rowIndex, colIndex) => {
    if (!selectedStatus) return;
    const newTableChallenge = [...tableChallenge];
    // If clear status is selected, set cell to null
    newTableChallenge[rowIndex][colIndex] =
      selectedStatus.status === 'clear' ? null : selectedStatus;
    setTableChallenge(newTableChallenge);
  };

  return (
    <div className="challenge-container">
      <div className="header-rate-day">
        <h1 className="h1-challenge">Monthly Challenge</h1>
        <ol>
          <li>Add a monthly challenge</li>
          <li>Pick a sign from the list below X or V</li>
          <li>Click on a cell to update your challenge</li>
          <li>See you again tomorrow </li>
        </ol>
      </div>
      <div>
        <h3 className="h3-months">Write your Monthly Challenge</h3>
        <div className="month-grid-container">
          {monthNames.map((month, index) => (
            <div key={index} className="month-grid-box">
              <label>{month}</label>
              <textarea
                type="text"
                value={monthTitles[index]}
                onChange={(e) => handleTitleChange(index, e.target.value)}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Day</th>
              {['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'].map(
                (month, index) => (
                  <th key={index}>{month}</th>
                ),
              )}
            </tr>
          </thead>
          <tbody>
            {tableChallenge.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{rowIndex + 1}</td>
                {row.map((cell, colIndex) => (
                  <td
                    key={colIndex}
                    onClick={() => handleStatusChange(rowIndex, colIndex)}
                    className="status-cell"
                  >
                    {cell && cell.icon && (
                      <img
                        src={cell.icon}
                        alt={cell.description}
                        className="status-icon"
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="status-picker-container">
          <div className="status-options">
            <h4>Pick your action:</h4>
            {statusOptions.map((option, index) => (
              <div
                key={index}
                onClick={() =>
                  setSelectedStatus(option === selectedStatus ? null : option)
                }
                className="status-option"
              >
                {option.icon ? (
                  <img
                    src={option.icon}
                    alt={option.description}
                    className={`status-icon ${
                      option.status === selectedStatus?.status
                        ? 'selected-status'
                        : ''
                    }`}
                  />
                ) : (
                  <img
                    src={clearIcon}
                    alt={option.description}
                    className={`status-icon ${
                      option.status === selectedStatus?.status
                        ? 'selected-status'
                        : ''
                    }`}
                  />
                )}
                <span className="status-description">{option.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
